export enum GroupContentTypesEnum {
  Groups = "Standard",
  Templates = "Inherited",
}
